import React from 'react';
import TimeEntryOverview from '../components/TimeEntryOverview';

const TimeEntriesPage = () => {
  return (
    <div>
      <h3 className="mb-3">Meine Zeiteinträge</h3>
      <TimeEntryOverview />
    </div>
  );
};

export default TimeEntriesPage;
